import { produce } from 'immer'
import { filter, find, findIndex, forEach, map, remove } from 'lodash'
import { PalletData } from '../apis/pallet.api'
import { WorkOrderData } from '../apis/workOrder.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'
import { TableVerticalData } from '../components/TableVertical'

export default {
  isExists (pallets: PalletData[], id: number) {
    const index = findIndex(pallets, { id })
    return (index !== -1)
  },

  tableHorizontalData (
    pallets: PalletData[],
    actions: ActionName[]
  ): TableHorizontalData<PalletData>[] {
    return produce(pallets, pallets => {
      const setActions = (pallet: TableHorizontalData<PalletData>) => {
        pallet.actions = actions
        if (!pallet.canRollback) {
          pallet.actions = filter(pallet.actions, action => action !== 'rollback')
        }
      }
      const setLocationName = (pallet: TableHorizontalData<PalletData>) => {
        const { aliveTransfer } = pallet
        if (aliveTransfer) {
          const { location } = aliveTransfer
          pallet.locationName = location
            ? location.name
            : aliveTransfer.type === 'ship' ? 'Shipped' : aliveTransfer.type
        }
      }
      const setWorkOrderCode = (pallet: TableHorizontalData<PalletData>) => {
        const { consumed, lastInternalTransfer } = pallet
        if (!lastInternalTransfer) return
        const transferable = lastInternalTransfer.transferable as WorkOrderData
        if (!transferable) return
        pallet.workOrderCode = consumed
          ? consumed.workOrder.code
          : transferable.code
      }
      forEach(pallets, (pallet: TableHorizontalData<PalletData>) => {
        setActions(pallet)
        setLocationName(pallet)
        setWorkOrderCode(pallet)
      })
    })
  },

  tableVerticalData (pallet: TableVerticalData): TableVerticalData {
    return produce(pallet, pallet => {
      const { attachedLicensePlates, aliveTransfer } = pallet
      if (attachedLicensePlates) {
        const { site, customer, customerSite } = attachedLicensePlates
        attachedLicensePlates.sites = site.join(', ')
        attachedLicensePlates.customers = customer.join(', ')
        attachedLicensePlates.customerSites = customerSite.join(', ')
      }
      pallet.attachedLicensePlates = attachedLicensePlates
      if (aliveTransfer) {
        const { location } = aliveTransfer
        pallet.locationName = location
          ? location.name
          : aliveTransfer.type === 'ship' ? 'Shipped' : aliveTransfer.type
      }
    })
  },

  bulkTransferTableHorizontalData (
    pallets: PalletData[]
  ): TableHorizontalData<PalletData>[] {
    forEach(pallets, (pallet: TableHorizontalData<PalletData>) => {
      const actions: ActionName[] = ['delete']
      pallet.actions = actions
    })
    return pallets
  },

  listIds (pallets: PalletData[]) {
    return map(pallets, pallet => pallet.id)
  },

  delete (pallets: TableHorizontalData<PalletData>[], id: number) {
    return produce(pallets, pallets => {
      remove(pallets, { id })
    })
  },

  find (pallets: PalletData[], id: number) {
    return find(pallets, { id })
  }
}
